
import Vue from 'vue'
import BackgroundLayout from '@/components/BackgroundLayout.vue'
import {TermsAndConditions} from "@/model/TermsAndConditions";

export default Vue.extend({
  name: 'BackgroundArticle',
  components: {
    BackgroundLayout,
  },
  props: {
    slug: {
      type: String,
    },
  },
  mounted() {
    this.fetch()
  },
  data: () => ({
    terms: null as TermsAndConditions | null,
  }),
  methods: {
    fetch: function () {
      this.$api
        .get('/contents/terms-and-conditions')
        .then((response) => {
          this.terms = response.data
        })
        .catch(() => this.$router.push('/404'))
    },
  },
  watch: {
    $route: function () {
      this.fetch()
    },
  },
})
